import { render } from "./FiltersSidebar.vue?vue&type=template&id=e4ff4e8e&ts=true&lang=pug"
import script from "./FiltersSidebar.vue?vue&type=script&lang=ts"
export * from "./FiltersSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__